import * as React from 'react'
import { formatMoney } from '../useChargebeeCheckout'
import { DisclosureToggle, inputClass } from './formParts'

const COUPON_FIELDS_ID = 'checkout-coupon-fields'

// `coupon` is the state of useCouponField.
export default function CouponField({ coupon }) {
    const [open, setOpen] = React.useState(Boolean(coupon.appliedCode))

    return (
        <div>
            <DisclosureToggle
                open={open}
                onToggle={() => setOpen(value => !value)}
                controls={COUPON_FIELDS_ID}
                testId="billing-coupon-toggle"
            >
                Have a coupon?
            </DisclosureToggle>
            {open ? (
                <div id={COUPON_FIELDS_ID} className="tw-mt-2 tw-flex tw-gap-2">
                    <input
                        className={inputClass}
                        placeholder="Coupon code"
                        aria-label="Coupon code"
                        value={coupon.draft}
                        onChange={event => coupon.change(event.target.value)}
                        onKeyDown={event => {
                            if (event.key !== 'Enter') return
                            event.preventDefault()
                            coupon.apply()
                        }}
                        data-testid="billing-coupon"
                    />
                    <button
                        type="button"
                        onClick={coupon.apply}
                        disabled={
                            !coupon.draft.trim() ||
                            coupon.applied ||
                            coupon.checking
                        }
                        data-testid="billing-coupon-apply"
                        className="tw-cursor-pointer tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground disabled:tw-opacity-50"
                    >
                        {coupon.checking
                            ? 'Checking…'
                            : coupon.applied
                            ? 'Applied'
                            : 'Apply'}
                    </button>
                </div>
            ) : null}
            {coupon.error ? (
                <p
                    className="tw-m-0 tw-mt-2 tw-text-sm tw-text-destructive"
                    role="alert"
                    data-testid="coupon-error"
                >
                    {coupon.error}
                </p>
            ) : null}
            {coupon.applied && coupon.saving && coupon.saving.amount ? (
                <p
                    className="tw-m-0 tw-mt-2 tw-text-sm tw-text-success"
                    data-testid="coupon-saving"
                >
                    {coupon.appliedCode} applied: you save{' '}
                    {formatMoney(coupon.saving.amount, coupon.saving.currency)}
                </p>
            ) : null}
        </div>
    )
}
